import { isMobile } from 'util/screen';

export const mapPropsToValues = ({ data = { results: { list: [] } } }) => {
  const reduceListData = (acc, product) => {
    acc[`${product.id}_product`] = product.quantity
      ? Number(product.quantity)
      : null;
    return acc;
  };

  const { list, mobileList } = data.results;

  const listToReduce = isMobile() && mobileList ? mobileList : list;

  const productsInitialValues = listToReduce.reduce(reduceListData, {}) || {};

  return {
    ...productsInitialValues,
    sort: '',
    sortAddProducts: '',
    sortMyProducts: ''
  };
};

export const VIEW_TYPES = {
  GRID: 'grid',
  LIST: 'list'
};
export const MODES = {
  GUEST: 'guest',
  EDIT: 'edit'
};
